import { Gender } from "@/constants";
import { cn } from "@/libs/cn";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Progress, Space } from "antd";
import { BsGenderFemale, BsGenderMale } from "react-icons/bs";

type RoomDrawerTitleProps = {
	room: Room;
	onClose: () => void;
};

export function RoomDrawerTitle(props: RoomDrawerTitleProps) {
	const {
		room: { name, gender, meditationEvent, count, maxiCount },
		onClose,
	} = props;

	const leftSpots = maxiCount - count;
	const noSpots = leftSpots == 0;

	return (
		<section className=" space-y-4">
			<div className="flex items-center justify-between">
				<article>
					<h2 className="text-xl font-semibold text-primary-gradient font-poppins">
						Room {name}
					</h2>
					<article className="flex items-center gap-2">
						<Space align="center">
							{(gender === Gender.MALE || gender === Gender.MONK) ? (
								<BsGenderMale size={12} color="gray" />
							) : (
								<BsGenderFemale size={12} color="gray" />
							)}
							<p className="text-sm text-gray-400/70 font-poppins">
								{gender}
							</p>
						</Space>
						<span className="size-1 rounded-full bg-gray-400/70" />
						<p className="text-sm text-gray-400/70 font-poppins">
							{meditationEvent?.level.name} -{" "}
							{meditationEvent?.title}
						</p>
					</article>
				</article>
				<Button
					onClick={onClose}
					shape="circle"
					size="large"
					type="text"
					icon={<CloseOutlined />}
					className="bg-gray-100! hover:bg-gray-200! text-base!"
					style={{
						border: "5px solid transparent",
						// borderImage: "var(--color-primary-gradient)",
					}}
				/>
			</div>
			<div className="space-y-1">
				<article className="flex items-center justify-between font-poppins text-sm">
					<p className="text-gray-500">
						{count} / {maxiCount} people
					</p>
					<p
						className={cn("text-success", {
							"text-danger": noSpots,
						})}
					>
						{leftSpots} spots left
					</p>
				</article>
				<Progress
					percent={(count * 100) / maxiCount}
					showInfo={false}
					strokeColor={"var(--color-primary-gradient)"}
				/>
			</div>
		</section>
	);
}
